import { Button, Avatar } from "@mui/material"
import { Group } from "@mui/icons-material"
import { H6, Body3, Body2, Body1 } from "../../../../../themes/typography"

export default function RegistrationOverview({
    data = [],
    onViewAllAttendees = () => { }
}) {
    return (
        <div className="event-dashboard-registration-overview">

            <div className="event-dashboard-registration-overview-wrapper">

                <div className="registration-overview-content">
                    <div className="registration-overview-title">
                        <H6 fontWeight={600}>
                            Registration
                        </H6>
                        <div className="registration-total">
                            <Body3>
                                Total {data?.length || 0}
                            </Body3>
                        </div>
                    </div>

                    <div className="latest-registrations-list">
                        {data?.length === 0 && (
                            // <Body2>No registrations found.</Body2>
                            <div className="no-system-alerts">
                                <div className="no-system-alerts-icon">
                                    <Group sx={{ fontSize: "3rem" }} color="inherit" />
                                </div>
                                <Body1 fontWeight={400}>
                                    No registrations found.
                                </Body1>
                                <Body2 color="var(--secondary-color)" fontWeight={350}>
                                    When attendees register for your event, their details will appear here.
                                </Body2>
                            </div>
                        )}

                        {data?.length > 0 && data.slice(0, 6).map((registration, index) => (
                            <EachRegistrationItem key={index} {...registration} />
                        ))}
                    </div>
                </div>

                <div className="view-all-registrations">
                    <Button
                        variant="lightToggleActiveSm"
                        fullWidth={true}
                        onClick={onViewAllAttendees}
                    >
                        View All Attendees
                    </Button>
                </div>
            </div>
        </div>
    )
}

function EachRegistrationItem(registration) {
    return (
        <div className="each-registration-item-container">
            <div className="each-registration-item-wrapper">

                <div className="registration-details">

                    <div className="attendee-avatar">
                        <Avatar sx={{ width: '38px', height: '38px' }}>
                            {registration?.attendee_name?.charAt(0)?.toUpperCase()}
                        </Avatar>
                    </div>
                    <div className="attendee-name-with-ticket">

                        <div className="registered-attendee-name">
                            <Body2 fontWeight={500}>
                                {registration?.attendee_name}
                            </Body2>
                        </div>
                        <div className="registered-ticket-type">
                            <Body3>
                                {registration?.ticket_type}
                            </Body3>
                        </div>

                    </div>
                </div>

                <div className="registrant-time">
                    <Body3>
                        {registration?.booked_on}
                    </Body3>
                </div>
            </div>
        </div>
    )
}